import { LearningTemplateQuestionContent } from './learning-template-question-content'
import type { LearningTemplateExerciseFrameProps } from './learning-template-contract'
import './learning-template-exercise-frame.css'

export function LearningTemplateExerciseFrame({
  children,
  className,
  content,
  hint,
  media,
  questionContent,
  questionText,
  sourceOwner,
}: LearningTemplateExerciseFrameProps) {
  const promptContent = questionContent ?? (questionText ? (
    <h2 className="learningTemplateExerciseQuestion">{questionText}</h2>
  ) : (
    <LearningTemplateQuestionContent content={content} />
  ))
  const rootClassName = ['learningTemplateExerciseFrame', className]
    .filter(Boolean)
    .join(' ')

  return (
    <div
      className={rootClassName}
      data-learning-template-exercise="true"
      data-legacy-owner={sourceOwner}
    >
      {promptContent ? (
        <div className="learningTemplateExercisePrompt">{promptContent}</div>
      ) : null}
      {hint ? <div className="learningTemplateExerciseHint">{hint}</div> : null}
      {media ? <div className="learningTemplateExerciseMedia">{media}</div> : null}
      <div className="learningTemplateExerciseAnswer">{children}</div>
    </div>
  )
}
